import React from 'react';
import { Chip } from '@material-ui/core';

interface ChipSetProps {
  max: number;
  values: string[];
}

export const ChipSet = ({ max, values = [] }: ChipSetProps) => {
  const chipsToShow = values.slice(0, max);
  const remainingChipsCount = values.length - chipsToShow.length;

  return (
    <span
      style={{
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
        height: '100%',
      }}
    >
      {chipsToShow.map((label: string) => (
        <Chip color="primary" key={label} label={label} />
      ))}
      {remainingChipsCount > 0 && (
        <>
          ...
          <Chip label={`+${remainingChipsCount}`} variant="outlined" />
        </>
      )}
    </span>
  );
};
